import React, { useCallback } from "react"
import { GoogleMap, Marker, Polygon } from "@react-google-maps/api"
import '../css/GM.css'
import kav_yarok from "../data/kav_yarok.json"

function latRad(lat) {
    var sin = Math.sin(lat * Math.PI / 180);
    var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
    return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
}

function zoom(mapPx, worldPx, fraction) {
    return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
}

function getBoundsZoomLevel(bounds, mapDim) {
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;
    var ne = { lat: bounds["north"], lng: bounds["east"] };
    var sw = { lat: bounds["south"], lng: bounds["west"] };
    var latFraction = (latRad(ne["lat"]) - latRad(sw["lat"])) / Math.PI;
    var lngDiff = ne["lng"] - sw["lng"];
    var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;
    var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);
    return Math.min(latZoom, lngZoom, ZOOM_MAX);
}

const containerStyle = {
    width: '100%',
    height: '450px'
};

const MyMapComponent = (props) => {
    const onLoad = useCallback(function callback(map) {}, []);

    const onUnmount = useCallback(function callback(map) {}, []);

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            zoom={getBoundsZoomLevel(props.bounds, { height: 450, width: 850 })}
            center={{ lat: props.center["lat"], lng: props.center["lng"] }}
            options={{ streetViewControl: false, mapTypeControl: false, clickableIcons: false }}
            onLoad={onLoad}
            onUnmount={onUnmount}
        >
            {
                props.show["kalpies"] && props.markersToRender.map((kalpi, index) => (
                    <Marker
                        key={`kalpi-${index}`}
                        position={{ lat: kalpi["lat"], lng: kalpi["lng"] }}
                        title={kalpi["address"] + ", " + kalpi["votes"] + " קולות"}
                        icon={{
                            url: "http://maps.google.com/mapfiles/kml/pal4/icon25.png"
                        }}
                    />
                ))
            }
            {
                props.show["numbers"] && props.clustersToRender.map((cluster, index) => (
                    <Marker
                        key={`cluster-${index}`}
                        position={{ lat: cluster["real_centroid"]["lat"], lng: cluster["real_centroid"]["lng"] }}
                        label={{
                            text: cluster["cluster_num"].toString(),
                            fontSize: "6px"
                        }}
                        icon={{
                            url: "https://maps.google.com/mapfiles/ms/icons/lightblue.png",
                            labelOrigin: { x: 16, y: 9 }
                        }}
                        title={cluster["votes"] + " קולות "}
                    />
                ))
            }
            {
                props.show["polygons"] && props.clustersToRender.map((cluster, index) => (
                    <Polygon
                        key={`polygon-${index}`}
                        paths={[cluster["polygon_pts"][0], cluster["polygon_pts"][1]]}
                        options={{
                            strokeWeight: 2,
                            strokeColor: cluster["color"],
                            fillColor: cluster["color"],
                            fillOpacity: 0.3
                        }}
                    />
                ))
            }
            {props.show["polygons"] && props.clustersToRender.length === 120 &&
                <Polygon
                    paths={[kav_yarok["polygon_pts"]]}
                    options={{
                        strokeWeight: 2,
                        strokeColor: "green",
                        fillColor: "green",
                        fillOpacity: 0.2
                    }}
                />
            }
        </GoogleMap>
    );
}

class GM extends React.PureComponent {
    render() {
        return (
            <MyMapComponent
                key={this.props.showPolicy}
                markersToRender={this.props.markersToRender}
                clustersToRender={this.props.clustersToRender}
                center={this.props.center}
                bounds={this.props.bounds}
                show={this.props.showPolicy}
            />
        )
    }
}

export default GM;